import {PAGES} from "../../../../core/consts";
import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {CompetitionBracketsPageRouteConfig} from "./models/competition-brackets-page.route.config";

export class CompetitionBracketsPageConfig extends BaseConfig {
  static injectables = [CompetitionBracketsPageRouteConfig];

  constructor(route: CompetitionBracketsPageRouteConfig) {
    super(PAGES.COMPETITION.brackets, route);
  }
}
